/* src/app/forms/produtos/mercadolivre/meli-edit-form/fields-data-select/fields-data-select.component.scss */
.container {
  padding: 20px;
}
.content {
  position: relative;
  padding: 6px;
  margin: 16px;
  height: 60vh;
  overflow: auto;
}
.data-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}
.data-card {
  cursor: pointer;
  border: 1px solid var(--tem-border, #f0f0f0);
  border-radius: var(--tem-radius, 8px);
  background: var(--tem-surface, #fff);
  padding: 12px 16px;
  transition: box-shadow 0.3s;
}
.data-card:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.4);
}
.field-name {
  font-weight: 500;
}
.field-value {
  color: var(--tem-muted, rgba(0, 0, 0, 0.45));
  font-size: var(--tem-fs-sm, 12px);
  word-break: break-word;
}
/*# sourceMappingURL=fields-data-select.component.css.map */
